module.exports = __webpack_public_path__ + "static/media/luxtrust-mobile@3x.a16c31f9.png";